<template>
  <base-modal
    :ref="modal.key"
    :title="modal.title"
    :show="open"
    @on-confirm="save"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    :maxWidth="700"
  >
    <v-form class="mt-5">
      <v-text-field
        v-bind:label="$t('Title')"
        v-model="widgetTitle"
      ></v-text-field>

      <ColorPicker :label="$t('Color')" v-model="model.color" />

      <BaseDualList
        :source="availablesBasket"
        :destination="model.filter"
        item-text="text"
        item-id="id"
        @onChangeList="onBasketListChange"
      />
    </v-form>
  </base-modal>
</template>
<script>
import WidgetService from "@/services/WidgetService";
import WidgetSettings from "@/ecm/models/widget/basket/BasketSettings";
import WidgetType from "@/ecm/variables/WidgetType";
import ColorPicker from "@/components/widgets/ColorPicker";

export default {
  components: { ColorPicker },
  data() {
    return {
      loadingBasketList: false,
      basketList: [],
      availablesBasket: [],
      id: 0,
      model: new WidgetSettings(),
      modal: {
        title: this.$t("Settings"),
        key: "userModal",
      },
      open: false,
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    widgetTitle: {
      get() {
        if (this.model.widgetTitle) {
          return this.model.widgetTitle;
        } else {
          return this.$t("Baskets");
        }
      },
      set(val) {
        this.model.widgetTitle = val;
      },
    },
  },
  methods: {
    async save() {
      this.modalInstance.progress(true);

      const model = Object.assign(new WidgetSettings(), this.model);

      var widgetDto = {
        Id: this.id,
        WidgetID: WidgetType.Baskets,
        Settings: model.toDto(),
      };

      WidgetService.updateSettings(widgetDto)
        .then((data) => {
          this.open = false;
          this.$emit("on-save", model.toDto());
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    show(id, dto) {
      this.id = id;
      this.model = new WidgetSettings(dto);
      this.loadData();
      this.open = true;
    },
    hide() {
      this.open = false;
    },
    loadData() {
      this.loadBasketList(this.model.filter);
    },
    onBasketListChange: function ({ destination, source }) {
      this.availablesBasket = source;
      this.model.filter = destination;
    },
    loadBasketList(filter) {
      this.loadingBasketList = true;
      WidgetService.getData({
        WidgetID: WidgetType.Baskets,
      }).then((data) => {
        this.basketList = data.map((d) => {
          return { id: d.Id + "", text: d.Description };
        });
        this.model = { ...this.model, filter: filter };

        var availablesBasket = [...this.basketList];

        for (let i = 0; i < this.model.filter.length; i++) {
          const selected = this.basketList.find(
            (b) => b.id == this.model.filter[i].id
          );

          if (selected) {
            this.model.filter[i].text = selected.text;

            availablesBasket = availablesBasket.filter((x) => {
              return x.id != selected.id;
            });
          }
        }

        this.availablesBasket = availablesBasket;

        this.loadingBasketList = false;
      });
    },
  },
};
</script>